import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { resetDownloadTypeToRegular } from "../../DownloadAndDelete/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import CommonHeader from "common-components/Header";
import Container from "common-components/Container";
import { TitleLockup } from "@vds/type-lockups";
import { media, isMobile } from "utils/style";
import ReactButton from "common-components/Buttons";

class AuthorizedAgentAffidavitPrimer extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Affidavit primer", this.props.pageContent.sc_pagetitle);
    }
  }

//   resetDownloadTypeToRegular = () => {
//     this.props.resetDownloadTypeToRegular();
//     this.props.history.push("/privacy/secure/authorized-agent/download-amount", {
//       confirmAuth: true,
//       fromAuthorizedAgent: true
//     });
//   };

  render() {
    const { pageContent } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    return (
      <Container>
        {/* DPCMP - 3792, 3791 */}
        <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    primitive:'p',
                    children: <Div> {convertStringToElements(pageContent.section_description)} </Div>
                    }

               }}
            
            
        />
        {/* <Header style={{ maxWidth: "346px" }}>{convertStringToElements(pageContent.section_title)}</Header>
        <Div>{convertStringToElements(pageContent.section_description)}</Div> */}
        <ButtonContainer>
        <Button
          background={pageContent.buttons[0].type}
          onClick={() =>
            this.props.history.push("/privacy/secure/authorized-agent/download/affidavit", {
              ...this.props.location.state
            })
          }
        >
          {pageContent.buttons[0].text}
        </Button>
        <Button background={pageContent.buttons[1].type} onClick={()=>
          this.props.history.push("/privacy/secure/authorized-agent/request-download",{
            confirmAuth:true
          })}>
            {pageContent.buttons[1].text}
          </Button>
        </ButtonContainer>
      </Container>
    );
  }
}

const mapStateToProps = ({ downloadAndDelete, pageContent }) => ({
  noOfRegularDownloadRemaining: downloadAndDelete.noOfRegularDownloadRemaining,
  pageContent: pageContent.affidavit_primer
});

export default connect(
  mapStateToProps,
  { resetDownloadTypeToRegular, setA11yContent }
)(AuthorizedAgentAffidavitPrimer);


const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 12px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300`;

const Div = styled.div`
  max-width: 422px;
  margin-bottom: 56px;
  p {
    padding: 10px 0;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  ${media.mobile`
   flex-direction: column;
  `}
`;
const Button = styled(ReactButton)`
  font-size: 14px;
`;
